import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@shared/ui/button";
import { TooltipProvider } from "@shared/ui/tooltip";
import { Plus } from "lucide-react";
import { SystemAlertTable } from "./components/SystemAlertsList";
import { SystemAlertsKpiCards } from "./components/SystemAlertsKpiCards";

const Landing: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="">
      <div className="space-y-6">
        {/* Header */}
        <div className="flex justify-between items-center">
          <div>
            <h1 className="page-title">System Alerts</h1>
            <p className="page-subtitle">
              AI-powered proactive maintenance recommendations
            </p>
          </div>
        </div>

        {/* KPI Cards */}
        <SystemAlertsKpiCards />

        {/* System Table */}
        <SystemAlertTable />
      </div>
    </div>
  );
};

export default Landing;
